const _ = require('lodash');

class StoreService {
    constructor(restangular, storeFilterService, locationService) {
        this._storeLocatorApi = restangular.one('StoreLocator');
        this._suburbsApi = this._storeLocatorApi.one('Suburbs');
        this._storesApi = this._storeLocatorApi.one('Stores');

        this.filterService = storeFilterService;
        this.locationService = locationService;
        this.isGeolocationEnabled = false;

        locationService.getCurrentLocation().then((isEnabled) => {
            this.isGeolocationEnabled = isEnabled;
        });
    }

    getDefaultLocation() {
        return this._storeLocatorApi.one('DefaultLanding').get();
    }

    searchStoresByRoute(route) {
        return this._storesApi.get({
            RoutePoint: route.overview_polyline,
            Division: this.filterService.getDivisionCodes().join(','),
            Facility: this.filterService.getFacilityCodes().join(','),
        })
            .then(response => (response && response.Stores ? response.Stores : []));
    }

    searchStoresByCoordinates(coordinates, max = 10, divisions = this.filterService.getSelectedDivisions(), facilities = this.filterService.getSelectedFacilities()) {
        return this._storesApi.get(_.assign({}, coordinates, {
            Division: this.filterService.getDivisionCodes(divisions).join(','),
            Facility: this.filterService.getFacilityCodes(facilities).join(','),
            Max: max,
        }))
            .then(response => (response && response.Stores ? response.Stores : []));
    }

    searchStoresByPostcode(postcode, max = 10, divisions = this.filterService.getSelectedDivisions(), facilities = this.filterService.getSelectedFacilities()) {
        return this._storesApi.get({
            PostCode: postcode,
            Division: this.filterService.getDivisionCodes(divisions).join(','),
            Facility: this.filterService.getFacilityCodes(facilities).join(','),
            Max: max,
        })
            .then(response => (response && response.Stores ? response.Stores : []));
    }

    searchSuburbs(searchTerm) {
        return this._suburbsApi.get({
            SearchTerm: searchTerm,
        }).then(response => (response && response.Suburbs ? response.Suburbs : []));
    }

    getStore(storeNo, division) {
        return this._storeLocatorApi.one('Store')
            .get({ StoreNo: storeNo, Division: division })
            .then(response => response.plain());
    }

    /**
    * Gets a unique identifier for a store. (Store numbers are not unique).
    * @param {any} store
    */
    getStoreKey(store) {
        return `${store.Division}${store.AddressLine1}`;
    }

    getStoreUrl(store) {
        let url = `${store.State.trim()} ${store.Suburb.trim()} ${store.StoreNo.trim()}`;

        if (store.Division !== 'SUPERMARKETS') {
            url = `${url}-${store.Division}`;
        }

        return url
            .replace(/[^a-zA-Z0-9]/g, ' ')
            .replace(/\s+/g, '-');
    }

    getStoreInfoFromUrlParams(storeParam) {
        let storeInfo;
        const params = storeParam.split('-');
        const lastIndexOfParams = params.length - 1;
        let division = null;

        // check that we have enough parameters
        if (params.length >= 3) {
            // parse store number
            let storeNo = parseInt(params[lastIndexOfParams], 10);

            // if the last parameter is not a number, then it is the division
            if (_.isNaN(storeNo)) {
                storeNo = parseInt(params[lastIndexOfParams - 1], 10);
                division = params[lastIndexOfParams];
            }

            // only continue if storeNo is a valid number
            if (storeNo) {
                // get the suburb
                const suburbArray = params.slice(1, division ? lastIndexOfParams - 1 : lastIndexOfParams);

                storeInfo = {
                    storeNo,
                    suburb: suburbArray.join(' '),
                    state: params[0],
                    division: division || 'SUPERMARKETS',
                };
            }
        }

        return storeInfo;
    }

    urlParametersValid(store, parameters) {
        return store.State === parameters.state && store.Suburb === parameters.suburb && parseInt(store.StoreNo) === parameters.storeNo;
    }

    setSelectedStore(store) {
        this.selectedStore = store;
    }

    isStoreEqual(store1, store2) {
        return this.getStoreKey(store1) === this.getStoreKey(store2);
    }

    isSelectedStore(store) {
        return !!(this.selectedStore && this.isStoreEqual(this.selectedStore, store));
    }

    getFormattedAddress(store) {
        if (!store) return '';
        const addressLine1 = !store.AddressLine1 || store.AddressLine1 === '' ? '' : `${store.AddressLine1}, `;
        const suburb = !store.Suburb || store.Suburb === '' ? '' : `${store.Suburb}, `;
        const state = !store.State || store.State === '' ? '' : `${store.State}, `;
        const postcode = !store.Postcode || store.Postcode === '' ? '' : `${store.Postcode}, `;
        return `${addressLine1}${suburb}${state}${postcode}Australia`;
    }
}

module.exports = StoreService;



// WEBPACK FOOTER //
// ./src/shop/stores/store.service.js